import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";

import { GET_SYSTEM_HEADER_VIEW } from "../../../queries/publicQrys/SystemHeaderViewQrys";
import SystemHeaderRibbon from "./SystemHeaderRibbon";
import AdminContact from "./AdminContact";
import SiteInformation from "./SiteInformation";
import PoliticalDistricts from "./PoliticalDistricts";
import SiteUpdates from "./SiteUpdates";
import { UserContext } from "../auth/UserContext";
import SystemLinks from "./SystemLinks";
import SkeletonLoader from "../loaders/SkeletonLoader";
import ErrorHandler from "../ErrorHandler";

const SystemHeaderView = ({ systemId }) => {
  const { user } = useContext(UserContext);
  const { loading, data, error } = useQuery(GET_SYSTEM_HEADER_VIEW, { variables: { systemId } });
  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  const system = data && data.getSystemHeaderViewBySystemId;

  return (
    <React.Fragment>
      <Row>
        <Col>
          <SystemHeaderRibbon systemHeaderView={system} />
        </Col>
      </Row>
      <Row>
        <Col>
          <AdminContact adminContact={system.adminContact} />
        </Col>
        <Col>
          <SiteInformation
            SiteContact={system.SiteContact}
            county={system.countyServed}
            population={system.population}
            systemType={system.systemType}
          />
        </Col>
        <Col>
          <SiteUpdates system={system} />
        </Col>
        <Col>
          <PoliticalDistricts politicalDistricts={system.politicalDistricts} />
          {user.isStaff || user.isSysAdmin ? (
            <SystemLinks folderUrl={data.getSystemFolderUrl} coordinates={data.getSystemLatLongCoords} />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SystemHeaderView;
